import { withRouter } from 'react-router';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { removeCustomerFromWaitingList } from './actions';

const RemoveFromWaitingListLink = ({
  isFetching,
  successMessage,
}) => {
  const message = (() => {
    if (isFetching) {
      return 'Removing customer from waiting list... Please wait...';
    }
    return successMessage;
  })();

  return (
    <div className="u-text-center">
      <h2 className="c-heading u-mv+">Remove customer from waiting list</h2>
      <div className="c-heading--large">{message}</div>
    </div>
  );
};

RemoveFromWaitingListLink.propTypes = {
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
};
RemoveFromWaitingListLink.defaultProps = {
  isFetching: false,
  successMessage: '',
};

export default compose(
  withRouter,
  connect(
    state => ({
      isFetching: state.confirmation.get('isFetching'),
      errorMessage: state.confirmation.get('errorMessage'),
      successMessage: state.confirmation.get('successMessage'),
    }),
    { removeCustomerFromWaitingList }
  ),
  lifecycle({
    componentDidMount() {
      this.props.removeCustomerFromWaitingList(this.props.params.customerId);
    },
  })
)(RemoveFromWaitingListLink);



// WEBPACK FOOTER //
// ./src/app/confirmation/RemoveFromWaitingList.jsx